import { ArrowRight, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLocation } from "react-router-dom";
import { GENERAL_PHONE, trackPhoneClick } from "@/config/contact";

const visibleRoutes = new Set(["/voor-scholen", "/voor-mentoren", "/lob-leerlijn", "/integratie", "/dashboard", "/dossier"]);

export default function StickyDemoCta() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!visibleRoutes.has(pathname)) return null;
  return (
    <div className="pointer-events-none fixed bottom-5 left-1/2 z-40 hidden -translate-x-1/2 lg:block">
      <div className="pointer-events-auto flex items-center gap-3 rounded-full border border-border bg-background/90 p-2 pl-4 shadow-large backdrop-blur-xl">
        <a
          href={GENERAL_PHONE.href}
          aria-label={GENERAL_PHONE.ariaLabel}
          onClick={() => trackPhoneClick("sticky_demo_cta")}
          className="inline-flex min-h-9 items-center gap-1.5 rounded-full px-2 text-sm font-semibold text-muted-foreground transition-colors hover:bg-muted hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Phone className="h-4 w-4" />
          <span className="xl:hidden">Bel ons</span>
          <span className="hidden xl:inline">{GENERAL_PHONE.display}</span>
        </a>
        <span className="h-5 w-px bg-border" aria-hidden="true" />
        <Button size="sm" onClick={() => navigate("/demo")} className="rounded-full px-5">
          Plan een kennismaking
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}